import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M10 19v-3.96 3.15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 19h5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "10", x: "16", y: "12", rx: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MonitorSmartphone";
const MonitorSmartphone = memo(themed(Icon));
export {
  MonitorSmartphone
};
//# sourceMappingURL=monitor-smartphone.js.map
